export const footerLinks = [
  {
    title: "ACADEMICS",
    links: [
      { text: "Programmes", href: "/academics/programmes" },
      { text: "Departments", href: "/academics/departments" },
      { text: "Research", href: "/academics/research" },
      {
        text: "Academic Calendar",
        href: "/docs/Final_Academic_Calendar_2026-27_Higher_Semester.pdf",
      },
      {
        text: "Academic Calendar for 1st year B.Tech Students",
        href: "https://assets.iiitdwd.ac.in/docs/1st_Semester_Academical_Calendar_AY_2026-27.pdf",
      },
      {
        text: "Curriculum",
        href: "https://iiitdwd.ac.in/docs/Curricula_16May23.pdf",
      },
      {
        text: "Convocation",
        href: "https://www.youtube.com/watch?v=Sh5VyQxKQvk",
      },
      { text: "NIRF", href: "/academics/nirf" },
    ],
  },
  {
    title: "CAMPUS LIFE",
    links: [
      // { text: 'Student Life', href: '/student-life/clubs/tech/' },
      // { text: 'Hostel', href: '/student-life/hostel' },
      // { text: 'Sports and Games', href: '/student-life/non-tech' },
      { text: "Tech Clubs", href: "/student-life/clubs/tech" },
      {
        text: "Non-Tech Clubs",
        href: "/student-life/clubs/non-tech",
      },
      // { text: 'NSS', href: '/student-life/nss' },
      // { text: 'Student Achievements', href: '/student-life/achievements' }
    ],
  },
  {
    title: "INFORMATION",
    links: [
      { text: "About Institute", href: "/about" },
      { text: "Admissions", href: "/admission" },
      {
        text: "Internal Complaints Committee (ICC)",
        href: "/icc",
      },
      {
        text: "Fee Structure",
        href: "/admission/btech",
      },
      {
        text: "Annual Reports",
        href: "/annual-reports",
      },
      { text: "Career Guidance Cell", href: "/placements" },
      { text: "Faculty", href: "/academics/faculty" },
      {
        text: "Website Team",
        href: "/website-team",
      },
      { text: "RTI", href: "/RTI" },
      {
        text: "IIIT Laws 2020",
        href: "/docs/Indian_Institutes_of_Information_Technology_Laws__Amendment__Act__2020.pdf",
      },
      {
        text: "IDP (One nation one subscription)",
        href: "https://idp.iiitdwd.ac.in/",
      },
    ],
  },
  {
    title: "CONNECT",
    links: [
      { text: "Director", href: "/director" },
      { text: "Contact", href: "/contact" },
      // { text: 'Virtual Tour', href: '/gallery' },
      { text: "Careers", href: "/careers" },
      { text: "Tenders", href: "/tenders" },
      // { text: 'Campus', href: '/campus' },
      // {
      //   text: 'Public Disclosures',
      //   href: '/administration/public-disclosures'
      // }
    ],
  },
];
